<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户事件流</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="日期" prop="date">
            <el-date-picker v-model="queryParams.date" size="small" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="用户ID" prop="id">
            <el-input v-model.number="queryParams.id" size="small" placeholder="请输入用户ID" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-collapse v-model="activeNames" v-loading="loading" @change="handleCollapseChange">
          <el-empty v-if="tableData.length === 0" description="暂无数据" />
          <el-collapse-item v-for="item in tableData" v-else :key="item.uid +'-'+ item.eid" :title="handleTitle(item)" :name="item.uid +'-'+ item.eid">
            <el-descriptions class="margin-top" :column="4" size="small" border>
              <el-descriptions-item v-for="entry in getFilteredEntries(item.eventData)" :key="entry.key" :label="entry.key">
                {{ entry.value }}
              </el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
        </el-collapse>
        <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import { eventFlow } from '@/api/statistics/event/event'
import { timestampToDate } from '@/api/date'

export default {
  name: 'EventFlow',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 15,
        id: '',
        date: ''
      },
      activeNames: [],
      loading: false,
      total: 0,
      tableData: [],
      filterKeys: ['common', 'device_id', 'time']
    }
  },
  created() {
    const cache = sessionStorage.getItem('EventFlow')
    if (cache != null) {
      this.queryParams = JSON.parse(cache)
    }
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.date === '' || this.queryParams.date == null) {
        this.msgError('请选择日期')
        return
      }
      if (this.queryParams.id === '' || this.queryParams.id == null) {
        this.msgError('请输入用户ID')
        return
      }
      sessionStorage.setItem('EventFlow', JSON.stringify(this.queryParams))
      this.getTables()
    },
    getTables() {
      this.loading = true
      eventFlow(this.queryParams).then(res => {
        this.loading = false
        this.tableData = res.data.list
        this.total = res.data.count
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].eventData.common !== undefined && this.tableData[i].eventData.common !== null) {
            try {
              const tmp = JSON.parse(this.tableData[i].eventData.common)
              for (const key in tmp) {
                this.tableData[i].eventData[key] = tmp[key]
              }
            } catch (e) {
              console.error('解析common字段失败', e)
            }
          }
        }
        console.log(this.tableData)
      }).catch(err => {
        this.loading = false
        this.msgError('加载数据失败')
        console.error(err)
      })
    },
    handleCollapseChange(val) {

    },
    handleTitle(item) {
      return timestampToDate(item.time) + ' ' + item.eventName
    },
    getFilteredEntries(eventData) {
      if (!eventData || typeof eventData !== 'object') return []
      const result = []
      for (const key in eventData) {
        if (!this.filterKeys.includes(key)) {
          result.push({ key, value: eventData[key] })
        }
      }
      return result
    }
  }
}
</script>

<style scoped>
</style>
